import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionInfraCloud from '../../components/InfraCloud/IntroSectionInfraCloud/IntroSectionInfraCloud';
import IntroSectionInfraCloud2 from '../../components/InfraCloud/IntroSectionInfraCloud/IntroSectionInfraCloud2';
import IntroSectionInfraCloud3 from '../../components/InfraCloud/IntroSectionInfraCloud/IntroSectionInfraCloud3';
import Navbar from "../../components/Common/Navbar/Navbar";
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData4 from '../../components/Common/IntroSectionBottom/introSectionData4';
import useSectionRefs from '../../hooks/useSectionRefs';
import TimelineSecureTeleworking from '../../components/InfraCloud/Timeline/TimelineSecureTeleworking';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import PricingSectionAzureSecureTele from '../../components/ui/pricing-section-azure-securetele';

const SecureTeleworking: React.FC = () => {
    const { t } = useTranslation();
    const sectionRefs = useSectionRefs();

    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };

    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };


  return (
    <div style={{ position: 'relative' }}>
      {/* Page de maintenance overlay */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '20px',
        }}
      >
        <div
          style={{
            background: 'rgba(255, 255, 255, 0.98)',
            borderRadius: '24px',
            padding: '60px 40px',
            maxWidth: '600px',
            width: '100%',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
            animation: 'fadeInScale 0.5s ease-out',
          }}
        >
          <style>
            {`
              @keyframes fadeInScale {
                from {
                  opacity: 0;
                  transform: scale(0.9);
                }
                to {
                  opacity: 1;
                  transform: scale(1);
                }
              }
              @keyframes rotate {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
              @keyframes pulse {
                0%, 100% {
                  opacity: 1;
                }
                50% {
                  opacity: 0.5;
                }
              }
            `}
          </style>

          {/* Icon animé */}
          <div
            style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 30px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'pulse 2s ease-in-out infinite',
            }}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ animation: 'rotate 3s linear infinite' }}
            >
              <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
            </svg>
          </div>

          {/* Titre */}
          <h1
            style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#1a202c',
              marginBottom: '16px',
              lineHeight: '1.2',
            }}
          >
            {t('maintenance.title', 'Maintenance en cours')}
          </h1>

          {/* Description */}
          <p
            style={{
              fontSize: '18px',
              color: '#4a5568',
              marginBottom: '32px',
              lineHeight: '1.6',
            }}
          >
            {t(
              'maintenance.description',
              'Nous améliorons actuellement cette page pour vous offrir une meilleure expérience. Nous serons bientôt de retour !'
            )}
          </p>

          {/* Info supplémentaire */}
          <div
            style={{
              background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '32px',
            }}
          >
            <p
              style={{
                fontSize: '14px',
                color: '#667eea',
                fontWeight: '600',
                marginBottom: '8px',
              }}
            >
              {t('maintenance.estimate', 'Temps estimé')}
            </p>
            <p
              style={{
                fontSize: '16px',
                color: '#2d3748',
                fontWeight: '500',
              }}
            >
              {t('maintenance.time', 'Quelques heures')}
            </p>
          </div>

          {/* Bouton de retour */}
          <a
            href="/"
            style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              padding: '14px 32px',
              borderRadius: '12px',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: '600',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
            }}
          >
            {t('maintenance.backHome', 'Retour à l\'accueil')}
          </a>

          {/* Contact */}
          <p
            style={{
              fontSize: '14px',
              color: '#718096',
              marginTop: '24px',
            }}
          >
            {t('maintenance.contact', 'Une question urgente ?')}{' '}
            <a
              href="/contact"
              style={{
                color: '#667eea',
                textDecoration: 'none',
                fontWeight: '600',
              }}
            >
              {t('maintenance.contactLink', 'Contactez-nous')}
            </a>
          </p>
        </div>
      </div>

      {/* Contenu original de la page (masqué par l'overlay) */}
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header
            title={t('secureTeleworking.header.title', 'Sécuriser le Télétravail')}
            subtitle={t('secureTeleworking.header.subtitle', 'Protégez vos équipes et vos données en télétravail')}
          />
        </div>
      </section>
      
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionInfraCloud />
      </section>

      <section id="commitment" className="section light commitment-section" ref={sectionRefs.commitment}>
        <IntroSectionInfraCloud3 />
      </section>

      <section id="cloud" className="section dark" ref={sectionRefs.cloud}>
        <IntroSectionInfraCloud2 />
      </section>


        <div className="gradient-bg">
      <section id="start2" className="section light" ref={sectionRefs.start2}>
        <PricingSectionAzureSecureTele openContactModal={handleOpenContactModal} />
      </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
        <TimelineSecureTeleworking />
        <GridPatternCard>
          <GridPatternCardBody>
            <div className="tw-h-[5em]"></div>
          </GridPatternCardBody>
        </GridPatternCard>
          </section>
        </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
        <ContactLinkSection pageKey="infraCloud" />
        <Footer />
      </section>
    </div>
    </div>
    </div>
  );
};

export default SecureTeleworking;
